import "@/assets/scss/bootstrap.custom.scss";
import "@/assets/scss/bootstrap.layout.scss";
import "@/assets/scss/styles.scss";
import "@/assets/scss/uptime.scss";

// general imports
import "flag-icons/css/flag-icons.min.css";
import "react-datepicker/dist/react-datepicker.css";

import "bootstrap";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {RouterProvider} from "react-router";
import router from "./router.tsx";

function App() {
  return (
    <HelmetProvider>
      <Helmet defaultTitle="Uptime.com" titleTemplate="%s | Uptime.com" />
      <RouterProvider router={router} />
    </HelmetProvider>
  );
};

export default App;
